import { Flex } from '@chakra-ui/react'

import { useTranslation } from '~/lib/i18n'
import { DeeprStakingI } from '~/types'
import ModalButton from './ModalButton'
import StakeWithdrawDisclaimer from './StakeWithdrawDisclaimer'

interface Props {
  deeprStaking: DeeprStakingI
}

const StakeWithdrawForm = ({ deeprStaking }: Props) => {
  const { t } = useTranslation('staking')

  const { requestWithdraw, isLoadingWithdrawRequest } = deeprStaking

  return (
    <Flex direction="column" w="full">
      <StakeWithdrawDisclaimer showUnclaimedRewardsDisclaimer />
      <ModalButton onClick={requestWithdraw} isLoading={isLoadingWithdrawRequest} mt={6}>
        {t('modal.withdrawForm.button')}
      </ModalButton>
    </Flex>
  )
}

export default StakeWithdrawForm
